import React from "react";
import { format } from "date-fns";

import { Chip } from "@mui/material";

import BatchDetail from "../../../common/BatchDetail";
import ColumnHeader from "../../../common/ColumnHeader";
import { CLIENTS, getChipColor } from "../../../../constants/value";
import { dateSortComparator } from "../../../../utils/date";
import { __getPause } from "../../../../api/sim";

const COPY_KEYS = ["id", "batch_id", "iccid", "status", "last_updated"];

const pauseColumns = ({ handleColumnClick, client }) => [
  { field: "id", headerName: "ID", flex: 1, sortable: false },
  {
    field: "iccid",
    headerName: "ICCID",
    minWidth: 200,
    flex: 3,
    sortable: false,
    renderHeader: () =>
      client ? (
        <ColumnHeader label="ICCID" handleClick={() => handleColumnClick("iccid")} />
      ) : (
        "ICCID"
      ),
  },
  {
    field: "status",
    headerName: "Status",
    minWidth: 100,
    flex: 2,
    sortable: false,
    renderCell: (params) => (
      <Chip label={params.row.status} size="small" color={getChipColor(params.row.status)} />
    ),
  },
  {
    field: "created_at",
    headerName: "Created At",
    minWidth: 200,
    filterable: false,
    flex: 3,
    sortable: false,
    valueGetter: (params) => params.row.created_at || null,
    valueFormatter: (params) =>
      params.value && `${format(new Date(params.value), "MMMM d, y hh:mm a")}`,
    sortComparator: dateSortComparator,
  },
  {
    field: "last_updated",
    headerName: "Last Updated",
    minWidth: 200,
    filterable: false,
    flex: 3,
    sortable: false,
    valueGetter: (params) => params.row.last_updated || null,
    valueFormatter: (params) =>
      params.value && `${format(new Date(params.value), "MMMM d, y hh:mm a")}`,
    sortComparator: dateSortComparator,
  },
];

const TelitPauseBatch = () => (
  <BatchDetail
    title="Pause"
    apiGet={__getPause}
    client={CLIENTS.telit}
    columnsFactory={pauseColumns}
    copyKeys={COPY_KEYS}
    exportAction="pause"
    retryOperation="pause"
    showTerminate
    getRowPath={(row) => `/telit/pause/${row.id}`}
  />
);

export default TelitPauseBatch;
